/**
 * External dependencies
 */
import React from 'react';
import BasePopover from 'react-tiny-popover';
import { omit } from 'lodash';

/**
 * Style dependencies
 */
import './styles.scss';

const Popover = (props) => {
	return (
		<BasePopover
			enterExitTransitionDurationMs={props.enterExitTransitionDurationMs}
			//containerClassName={classNames('popover', 'is-' + props.position, props.className)}
			isOpen={props.isOpen}
			position='bottom'
			onClickOutside={props.onOuterAction}
			windowBorderPadding={20}
			disableReposition={true}
			//transitionDuration={0.000001} // there is a bug where it wont remove child if there is a transition
			content={props.isOpen ? <div className='popover__content'>{props.content}</div> : null}
			{...omit(props, ['content', 'ref'])}
		>
			{props.children}
		</BasePopover>
	);
};

Popover.defaultProps = {
	showArrow: true,
	preferPlace: 'below',
	enterExitTransitionDurationMs: 0,
};

export default Popover;
